export enum CommunicationStatus {
  Sending = 0,
  Sent = 1,
  Fail = 2,
  Confirmed = 3,
}

